import { render, staticRenderFns } from "./UpdateSapArea.vue?vue&type=template&id=ba72ec2a&"
import script from "./UpdateSapArea.vue?vue&type=script&lang=js&"
export * from "./UpdateSapArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports